import { Component, Input, SimpleChanges, OnChanges, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { Subscription } from 'rxjs';
import type { TreeEntity } from '../../../core/models/entity.model';
import type { EntityEditorPropertyChangedEvent } from '../../../entity-editor/models/entity-editor-property-changed.event';
import { ProjectDataActions } from '../../store/project-data/project-data.actions';
import { PropertyGroupType } from 'src/app/core/models/property-group-type.model';

@Component({
  selector: 'app-product-editor',
  templateUrl: './product-editor.component.html',
  styleUrls: ['./product-editor.component.scss'],
  standalone: false
})
export class ProductEditorComponent implements OnInit, OnChanges, OnDestroy {
  selectedId = '';
  selectedEntity: TreeEntity;
  initialized = true;

  @Input() projectEntity: TreeEntity | null;
  @Input() filterGroups: any[];
  @Input() groupFilter: (group: PropertyGroupType) => boolean;

  navigationSubscription: Subscription;

  constructor(private store: Store, private route: ActivatedRoute, private router: Router, private changeDetector: ChangeDetectorRef) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.initializeComponent();
      }
    });
  }

  initializeComponent() {
    this.initialized = false;
    this.changeDetector.detectChanges();
    this.selectedId = this.route.snapshot.queryParamMap.get('selectedId');
    this.initialized = true;
    this.setSelectedEntity();
  }

  ngOnInit() {
    this.initializeComponent();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectEntity']) {
      this.setSelectedEntity();
    }
  }

  ngOnDestroy(): void {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  setSelectedEntity() {
    if (this.selectedId) {
      this.selectedEntity = this.findInTreeById(this.projectEntity, this.selectedId);
    } else {
      this.selectedEntity = null;
    }
  }

  findInTreeById(selector: TreeEntity, id: string): TreeEntity {
    if (selector === null) {
      return null;
    }
    if (selector.Id === id) {
      return selector;
    }
    for (const child of selector.Children) {
      const candidate = this.findInTreeById(child, id);
      if (candidate !== null) {
        return candidate;
      }
    }
    return null;
  }

  propertyChanged(event: EntityEditorPropertyChangedEvent): void {
    this.store.dispatch(
      ProjectDataActions.update_project_start({
        entityId: this.selectedEntity.Id,
        propertyKey: event.propertyKey,
        newValue: event.value,
        measurementUnit: event.measurementUnit
      })
    );
  }
}
